import { LAYOUTS, ModalAlignmentEnum } from '@voltmoney/types';
import { InputStateToken, WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from './types';
import { closeOtpModalAction, failedVerifiction, onChangeInput, onClosePopup, onDisableSubmit, onLoad, onSendOTPAction, onTriggerCTA, verifyOTPAction } from './actions';
import { heightMap } from '../../configs/height';
import sharedPropsService from "../../SharedPropsService";
import { isMobile, setAppHeader } from "../../configs/utils";
import { StoreKey } from "../../configs/api";
const _isMobile = isMobile();
export const template = async (isCtaActive, isPrevRouteLeads, pan, phoneNumber, height, currentActiveTabIndex, currentPage, searchContext) => ({
    layout: {
        id: ROUTE.REGISTER_LEADS,
        type: _isMobile ? LAYOUTS.LIST : LAYOUTS.MODAL,
        style: _isMobile ? {
            isPartnerPlatform: true,
        } : {
            height: heightMap[ROUTE.VOLT_APP],
            alignment: ModalAlignmentEnum.RIGHT,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            isPartnerPlatform: true,
        },
        widgets: [
            { id: 'partnerRegisterLeads', type: WIDGET.PARTNER_REGISTER_LEADS, padding: { left: 0, right: 0, top: 0, bottom: 0 } }
        ],
    },
    datastore: {
        partnerRegisterLeads: {
            height: height,
            cancelAction: {
                routeId: ROUTE.REGISTER_LEADS,
                type: ACTION.CLOSE_POP_UP,
                payload: { currentActiveTabIndex, currentPage, searchContext },
            },
            sendOTPAction: {
                type: ACTION.SEND_OTP_ACTION,
                routeId: ROUTE.REGISTER_LEADS,
                payload: {}
            },
            verifyOTPAction: {
                routeId: ROUTE.REGISTER_LEADS,
                type: ACTION.VERIFY_OTP_ACTION,
                payload: {}
            },
            closeOtpModalAction: {
                routeId: ROUTE.REGISTER_LEADS,
                type: ACTION.CANCEL_OTP_ACTION,
                payload: {}
            },
            userMobileNumber: phoneNumber,
            otpState: InputStateToken.DEFAULT,
            showOTPModal: false,
            showErrorCard: false,
            errorMessage: '',
            errorCode: ''
        },
    },
});
export const registerLeadsMF = {
    onLoad: async ({ asyncStorage, setDatastore, getHeight }, { user, isPrevRouteLeads, pan, phoneNumber, preFill, currentActiveTabIndex, currentPage, searchContext }) => {
        await setAppHeader();
        const isCtaActive = await sharedPropsService.getRegisterLeadButtonActive();
        const u_data = JSON.parse(await asyncStorage.get(StoreKey.U_DATA));
        let _pan = u_data?.pan;
        let _phoneNumber = u_data?.phoneNumber;
        if (preFill) {
            _pan = pan;
            _phoneNumber = phoneNumber;
        }
        return Promise.resolve(template(isCtaActive, isPrevRouteLeads, _pan, _phoneNumber, getHeight(), currentActiveTabIndex, currentPage, searchContext));
    },
    actions: {
        [ACTION.CLOSE_POP_UP]: onClosePopup,
        [ACTION.CHANGE_INPUT_PAN]: onChangeInput,
        // [ACTION.PAN_SUCCESS_ACTION]: onPanSuccess,
        [ACTION.CHANGE_INPUT_DOB]: onChangeInput,
        [ACTION.CHANGE_INPUT_PHONE]: onChangeInput,
        [ACTION.CHANGE_INPUT_EMAIL]: onChangeInput,
        [ACTION.TRIGGER_CTA]: onTriggerCTA,
        [ACTION.DISABLE_SUBMIT]: onDisableSubmit,
        [ACTION.FAILED_VERIFICATION]: failedVerifiction,
        [ACTION.ON_LOAD]: onLoad,
        [ACTION.SEND_OTP_ACTION]: onSendOTPAction,
        [ACTION.VERIFY_OTP_ACTION]: verifyOTPAction,
        [ACTION.CANCEL_OTP_ACTION]: closeOtpModalAction,
    },
    action: {
        type: ACTION.ON_LOAD,
        routeId: ROUTE.REGISTER_LEADS,
        payload: {}
    }
};
